import { render, staticRenderFns } from "./FbLikertSection.vue?vue&type=template&id=440e77b8"
import script from "./FbLikertSection.vue?vue&type=script&lang=js"
export * from "./FbLikertSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports